import { configureStore } from "@reduxjs/toolkit";
import { loginDataReducer } from "./slices/user";
import { computedSlice } from "../redux/slices/computed";
import { calculateSignalsMiddleware, rtkErrorMiddleware } from "./middleware";
import { teApiSlice } from "./api/te";
import { registrationApiSlice } from "./api/registration";
import { languageSlice } from "./slices/lang";
import { noticeSlice } from "./slices/notice";
import { analyticsApiSlice } from "./api/analytics";
import { navigationSlice } from "./slices/navigation";

export const store = configureStore({
  reducer: {
    computed: computedSlice.reducer,
    login: loginDataReducer,
    language: languageSlice.reducer,
    notice: noticeSlice.reducer,
    navigation: navigationSlice.reducer,
    [teApiSlice.reducerPath]: teApiSlice.reducer,
    [registrationApiSlice.reducerPath]: registrationApiSlice.reducer,
    [analyticsApiSlice.reducerPath]: analyticsApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(teApiSlice.middleware)
      .concat(registrationApiSlice.middleware)
      .concat(rtkErrorMiddleware)
      .concat(calculateSignalsMiddleware)
      .concat(analyticsApiSlice.middleware);
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
